const TransactionParentStatus = {
    0: 'InProgress',
    1: 'Executed'
};

export default TransactionParentStatus;
